export default {"src":"/_next/static/media/WhatsApp.6459d21e.svg","height":29,"width":31,"blurWidth":0,"blurHeight":0};